import { withRouter, useLocation, useHistory } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import '../../fonts/fonts.css'
import SideBar from '../SideBar/index'
import PageHeader from '../../components/PageHeader'
import { connect, useSelector } from 'react-redux'
import { compose } from 'redux'
import injectSaga from '../../utils/injectSaga'
import Circle from '../../components/StatsCircle'
import { refreshSimuPlayersSaga } from '../RefreshPlayers/saga'
import config from '../../config/configurator'
import statsLogo from '../../images/Stats.svg'
import {
  TopMetricsGrid,
  MetricCard,
  MetricLabel,
  MetricValue,
  Percent,
  Bg,
  Stats,
  SkillsContainer,
  SkillSectionTitle,
  SkillList,
  SkillItem,
  SkillHeader,
  SkillName,
  Score,
  SkillProgressTrack,
  SkillProgressFill,
  CircleSection,
  MainLayout,
  MainContainer,
  Info,
  InfoContainer,
  SelectorStatsContainer,
  StatsSelector,
  DashboardContainer,
  StatCircleGrid,
  StatCard,
  StatLabel,
  CircleWrap
} from './styledComponents'
import Dashboard from '../../components/Dashboard'
import IOButtonSendData from '../../components/IOButton_SendData'

const StatsSimu = () => {
  const location = useLocation()
  const axios = require('axios')
  const history = useHistory()

  const simuPlayers = useSelector((state) => state.toJS().global.simuPlayers)
  const accessToken = useSelector((state) => state.toJS().global.agencytoken)
  const remoteToken = useSelector((state) => state.toJS().global.remotetoken)
  const entity = useSelector((state) => state.toJS().global.entity || 'TGD')

  const id = location.query
    ? location.query.id
    : location.pathname.split('/')[3]

  const [colors, setColors] = useState([' ', ' ', ' '])
  const [borderBottom, setBorderBottom] = useState([' ', ' ', ' '])
  const [circleSize, setCircleSize] = useState(80)
  const [stats, setStats] = useState({})
  const [skills, setSkills] = useState({})
  const [animateSkills, setAnimateSkills] = useState(false)
  const [statsAnimProgress, setStatsAnimProgress] = useState(0)

  const player = simuPlayers
  ? simuPlayers.find((player) => player.id === id || player.studentId === id)
  : ''


  useEffect(() => {
    console.log('LOCATION', location.pathname.split('/')[3])
    window.addEventListener('resize', ResizeCircle)
    
    if (simuPlayers) {
      const id = location.pathname.split('/')[3]
      console.log('ID', id)
      const player = simuPlayers.find((player) =>   player._id === id || player.studentId === id || player.id === id)
      console.log('FOUND player', player, stats)
      if (player /* && !stats */ /* && !isB2VM */) {
        if (config.title === 'ECF') {
          getAllProgression(player)
        } else {
          getStatsREMC(player)
          getSkillsREMC(player)
        }
      }
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    setAnimateSkills(false)
    setStatsAnimProgress(0)
  }, [id])

  const ResizeCircle = () => {
    setCircleSize(window.innerWidth / 17)
  }

  const getStatsREMC = async (player) => {
    console.log('GET STATS', player)
    await axios
      .get(
        `${process.env.REACT_APP_SERVER_API}/api/playerTGDs/${player.foreignKey}/getstatsremc?access_token=${remoteToken}`
      )
      .then((res) => {
        console.log('res data', res.data)
        setStats(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const getSkillsREMC = async (player) => {
    console.log('GET SKILLS', player)
    await axios
      .get(
        `${process.env.REACT_APP_SERVER_API}/api/playerTGDs/${player.foreignKey}/saveremc?access_token=${remoteToken}`
      )
      .then((res) => {
        setSkills(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const getAllProgression = async (player) => {
    console.log(`${process.env.REACT_APP_TGDAPI_SERVER}/progressions?studentId=${player.studentId}`)
    const headers = {
      Authorization: `Bearer ${accessToken}`
    }
    await axios
    .get(
      `${process.env.REACT_APP_TGDAPI_SERVER}/progressions?studentId=${player.studentId}`,
        {headers}
    )
    .then((res) => {
      progressionsToStatsFormatter(res.data)
      console.log('progressions response data:',res.data)
    })
    .catch((err) => {
      console.log(err)
    })
  }

  const progressionsToStatsFormatter = (progressions) => {

    let formattedSkills = {
      DistancePlay: 0,
      PlayTime: 0,
      Completion: {
        Counts: [0,0,0,0],
        Percents: [0,0,0,0],
        Count: 0,
        CountTotal: 55
      }
    }

    let formattedStats = {
      position_global: 0,
      allure_global: 0,
      retroviseur_global: 0,
      regard_global: 0,
      communication_global: 0,
      ecoStat: 0
    }

    let ratioStats = {
      position_global: 0,
      allure_global: 0,
      retroviseur_global: 0,
      regard_global: 0,
      communication_global: 0,
      ecoStat: 0
    }

    progressions.forEach((progression) => {
      // Skills

      const regex = /seq(\d)/
      const regexres = regex.exec(progression.sequenceId)

      if (regexres) {
          if (regexres[1] === '1') {
            formattedSkills.Completion.Counts[0]++
            formattedSkills.Completion.Percents[0] = formattedSkills.Completion.Counts[0] / 13 * 100
          } else if (regexres[1] === '2') {
            formattedSkills.Completion.Counts[1]++
            formattedSkills.Completion.Percents[1] = formattedSkills.Completion.Counts[1] / 16 * 100
          } else if (regexres[1] === '3') {
            formattedSkills.Completion.Counts[2]++
            formattedSkills.Completion.Percents[2] = formattedSkills.Completion.Counts[2] / 21 * 100
          } else if (regexres[1] === '4') {
            formattedSkills.Completion.Counts[3]++
            formattedSkills.Completion.Percents[3] = formattedSkills.Completion.Counts[3] / 5 * 100
          }
          formattedSkills.Completion.Count++
  
        formattedSkills.DistancePlay += progression.sessionDistance
        formattedSkills.PlayTime += progression.sessionTime
  
        // Stats
  
        if (progression.sectionScores) {
          progression.sectionScores.forEach((section) => {
            if (section.stats) {
              console.log(section.stats)
              if (section.stats.position > 0) {
                formattedStats.position_global += section.stats.position
                ratioStats.position_global++
                formattedStats.position_global = ratioStats.position_global !== 0 ? formattedStats.position_global / ratioStats.position_global : 0
              }
              if (section.stats.pace > 0) {
                formattedStats.allure_global += section.stats.pace
                ratioStats.allure_global++
                formattedStats.allure_global = ratioStats.allure_global !== 0 ? formattedStats.allure_global / ratioStats.allure_global : 0
              }
              if (section.stats.mirror > 0) {
                formattedStats.retroviseur_global += section.stats.mirror
                ratioStats.retroviseur_global++
                formattedStats.retroviseur_global = ratioStats.retroviseur_global !== 0 ? formattedStats.retroviseur_global / ratioStats.retroviseur_global : 0
              }
              if (section.stats.sight > 0) {
                formattedStats.regard_global += section.stats.sight
                ratioStats.regard_global++
                formattedStats.regard_global = ratioStats.regard_global !== 0 ? formattedStats.regard_global / ratioStats.regard_global : 0
              }
              if (section.stats.communication > 0) {
                formattedStats.communication_global += section.stats.communication
                ratioStats.communication_global++
                formattedStats.communication_global = ratioStats.communication_global !== 0 ? formattedStats.communication_global / ratioStats.communication_global : 0
              }
            }
          })
        }
      }
    })
    setStats(formattedStats)
    setSkills(formattedSkills)
  }

  const handleChangeStats = (event) => {
    if (event.value === 'TGD2') {
      history.push(`/simuplayers/statsb2vm/${id}`)
    }
  }

  function displayStatsSelector () {
    const statsValues = [
      {value: 'TGD1', label: 'TGD1'},
      {value: 'TGD2', label: 'TGD2'}
    ]
    return (
    <StatsSelector
      classNamePrefix='react-select'
      multiple={false}
      isSearchable={false}
      defaultValue={statsValues[0]}
      onChange={(e) => {handleChangeStats(e)}}
      options={statsValues}>
    </StatsSelector>)
  }

  const getTime = (time) => {
    if (time) {
      const h = parseInt(time / 60 / 60)
      const m = parseInt((time / 60) % 60)

      return h + 'h ' + m + 'm'
    }
    return 'Never played'
  }

  const formatDuration = (timeInSeconds) => {
    const safe = Math.max(0, timeInSeconds || 0)
    const h = parseInt(safe / 60 / 60)
    const m = parseInt((safe / 60) % 60)
    return h + 'h ' + m + 'm'
  }

  const formatScoreValue = (value) => {
    const rounded = Math.round((value || 0) * 10) / 10
    return Number.isInteger(rounded) ? rounded : rounded.toFixed(1)
  }

  const safeRatio = (value) => {
    if (typeof value !== 'number' || Number.isNaN(value)) return 0
    return Math.max(0, Math.min(1, value))
  }

  /* const update = async (id) => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/playerTGDs/${id}/getstatsremc?access_token=${accessToken}`)
    const data = await response.json()
    setStats(data)
  }

  const handleChange = (e) => {
    history.push(`/simuplayers/stats/${e.target.value}`)
    update(e.target.value)
  }
 */

  // const displaySelector = () => {
  //   if (simuPlayers) {
  //     return (
  //       <Selector style={{ marginTop: '4rem', outline: 'none' }} onChange={(e) => { handleChange(e) }} value={id}> {/* value={[player.get('id'), player.get('firstname'), player.get('lastname'), player.get('email'), player.get('agencyId')] */}
  //         {simuPlayers.map((pl, i = 0) => {
  //           if (pl.foreignKey === 'fkeditor') {
  //             return null
  //           }
  //           return <Opt key={i} value={pl.id}>{pl.firstname + ' ' + pl.lastname}</Opt>
  //         })}
  //       </Selector>
  //     )
  //   }
  // }

  // switch color in the infoContainer to know where we are
  const onClickColor = (e) => {
    setColors([
      e === 0 ? '#166DD8' : 'black',
      e === 1 ? '#166DD8' : 'black',
      e === 2 ? '#166DD8' : 'black',
    ])
    setBorderBottom([
      e === 0 ? '3px solid #166DD8' : 'black',
      e === 1 ? '3px solid #166DD8' : 'black',
      e === 2 ? '3px solid #166DD8' : 'black',
    ])
  }

  const ecoRatio = safeRatio(
    ((stats.ecoAccelerator_global || 0) +
      (stats.ecoStableSpeed_global || 0) +
      (stats.ecoBrakes_global || 0)) / 3
  )

  const scoreCards = [
    { label: 'Position', ratio: safeRatio(stats.position_global), value: Math.round(safeRatio(stats.position_global) * 100) || 0 },
    { label: 'Allure', ratio: safeRatio(stats.allure_global), value: Math.round(safeRatio(stats.allure_global) * 100) || 0 },
    { label: 'Rétroviseurs', ratio: safeRatio(stats.retroviseur_global), value: Math.round(safeRatio(stats.retroviseur_global) * 100) || 0 },
    { label: 'Regard', ratio: safeRatio(stats.regard_global), value: Math.round(safeRatio(stats.regard_global) * 100) || 0 },
    { label: 'Communication', ratio: safeRatio(stats.communication_global), value: Math.round(safeRatio(stats.communication_global) * 100) || 0 },
    { label: 'EcoConduite', ratio: ecoRatio, value: Math.round(ecoRatio * 100) || 0 }
  ]

  const getScoreTone = (value) => {
    if (value >= 75) {
      return {
        start: '#f7faf8',
        end: '#f1f6f3',
        border: '#d5e2db',
        label: '#41564a',
        halo: '#eef4f0',
        badge: '#e6eee9'
      }
    }
    if (value >= 50) {
      return {
        start: '#f8f9fc',
        end: '#f2f4f8',
        border: '#d9dee8',
        label: '#3f4f67',
        halo: '#edf1f7',
        badge: '#e5eaf3'
      }
    }
    return {
      start: '#fbf8f6',
      end: '#f6f1ee',
      border: '#e3d9d1',
      label: '#6d594b',
      halo: '#f3ede8',
      badge: '#ece3dc'
    }
  }

  useEffect(() => {
    const hasSkillData = Boolean(skills?.Completion)
    if (!hasSkillData) return

    const timeout = setTimeout(() => {
      setAnimateSkills(true)
    }, 80)

    return () => clearTimeout(timeout)
  }, [
    id,
    skills?.Completion?.Counts?.[0],
    skills?.Completion?.Counts?.[1],
    skills?.Completion?.Counts?.[2],
    skills?.Completion?.Counts?.[3]
  ])

  const doneCount = skills?.Completion ? (skills.Completion.Count || 0) : 0
  const doneTotal = skills?.Completion ? (skills.Completion.CountTotal || 0) : 0
  const targetPlayTime = skills?.PlayTime || 0
  const targetDistanceKm = (skills?.DistancePlay || 0) / 1000

  useEffect(() => {
    const hasData = Boolean(stats || skills)
    if (!hasData) return

    let rafId
    let startTime
    const duration = 700

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp
      const elapsed = timestamp - startTime
      const progress = Math.min(1, elapsed / duration)
      setStatsAnimProgress(progress)

      if (progress < 1) {
        rafId = window.requestAnimationFrame(step)
      }
    }

    setStatsAnimProgress(0)
    rafId = window.requestAnimationFrame(step)

    return () => {
      if (rafId) window.cancelAnimationFrame(rafId)
    }
  }, [
    id,
    doneCount,
    doneTotal,
    targetPlayTime,
    targetDistanceKm,
    scoreCards[0].value,
    scoreCards[1].value,
    scoreCards[2].value,
    scoreCards[3].value,
    scoreCards[4].value,
    scoreCards[5].value
  ])

  const animatedDoneCount = Math.round(doneCount * statsAnimProgress)
  const animatedDoneTotal = Math.round(doneTotal * statsAnimProgress)
  const animatedPlayTime = Math.round(targetPlayTime * statsAnimProgress)
  const animatedDistanceKm = targetDistanceKm * statsAnimProgress

  if (skills) {
    return (
      <Bg>
        <SideBar />
        <MainLayout>
          <PageHeader
            icon={statsLogo}
            title='Statistiques'
            subtitle={player ? `${player.firstname || ''} ${player.lastname || ''}`.trim() : 'Suivi de progression'}
          />
          <MainContainer>
            {/* <SelectorContainer>
              <ArrowStudent src={ArrowDown} />
              {displaySelector()}
            </SelectorContainer> */}
            <DashboardContainer>
              <Dashboard height={'48px'} type='infos' data={{firstName: player.firstname, lastName: player.lastname}}/>
              {entity === "IO" ?
                <div style={{position: 'absolute', right: '-60px', bottom: '0px'}}>
                  <IOButtonSendData
                    id={id}
                    accessToken={accessToken}
                  />
                </div>
              : null}
            </DashboardContainer>
            <InfoContainer>
            <Info
                to={`/simuplayers/edit/${id}`}
                style={{
                  color: colors[2],
                  borderBottom: borderBottom[2],
                }}
                onClick={(e) => onClickColor(2)}
              >
              Informations
            </Info>
            <Info
                to={`/simuplayers/trainings/${id}`}
                style={{
                  color: colors[1],
                  borderBottom: borderBottom[1],
                }}
                onClick={(e) => onClickColor(1)}
              >
              Formations
            </Info>
            <Stats
                style={{
                  color: colors[0],
                  borderBottom: borderBottom[0],
                }}
                onClick={(e) => onClickColor(0)}
              >
                Statistiques
              </Stats>
              {/* <Parcours
                style={{
                  color: colors[1],
                  borderBottom: borderBottom[1]
                }}
                onClick={(e) => onClickColor(1)}
              >
                Parcours
              </Parcours>
              */}
            </InfoContainer>
            <SelectorStatsContainer>
              {displayStatsSelector()}
            </SelectorStatsContainer>
            <TopMetricsGrid>
              <MetricCard>
                <MetricLabel>Trajets validés</MetricLabel>
                <MetricValue>{animatedDoneCount} / {doneTotal}</MetricValue>
              </MetricCard>
              <MetricCard>
                <MetricLabel>Temps de conduite</MetricLabel>
                <MetricValue>{formatDuration(animatedPlayTime)}</MetricValue>
              </MetricCard>
              <MetricCard>
                <MetricLabel>Kilomètres parcourus</MetricLabel>
                <MetricValue>{`${animatedDistanceKm.toFixed(1)} km`}</MetricValue>
              </MetricCard>
            </TopMetricsGrid>

            <SkillsContainer>
              <SkillSectionTitle>Progression des competences</SkillSectionTitle>
              <SkillList>
                {[
                  { label: 'Compétence 1', count: skills.Completion ? skills.Completion.Counts[0] || 0 : 0, total: 13, percent: skills.Completion ? skills.Completion.Percents[0] || 0 : 0 },
                  { label: 'Compétence 2', count: skills.Completion ? skills.Completion.Counts[1] || 0 : 0, total: 16, percent: skills.Completion ? skills.Completion.Percents[1] || 0 : 0 },
                  { label: 'Compétence 3', count: skills.Completion ? skills.Completion.Counts[2] || 0 : 0, total: 21, percent: skills.Completion ? skills.Completion.Percents[2] || 0 : 0 },
                  { label: 'Compétence 4', count: skills.Completion ? skills.Completion.Counts[3] || 0 : 0, total: 5, percent: skills.Completion ? skills.Completion.Percents[3] || 0 : 0 }
                ].map((item) => (
                  <SkillItem key={item.label}>
                    <SkillHeader>
                      <SkillName>{item.label}</SkillName>
                      <Score>{item.count}/{item.total}</Score>
                    </SkillHeader>
                    <SkillProgressTrack>
                      <SkillProgressFill style={{ width: animateSkills ? `${item.percent}%` : '0%' }} />
                    </SkillProgressTrack>
                  </SkillItem>
                ))}
              </SkillList>
            </SkillsContainer>

            <CircleSection>
              <StatCircleGrid>
                {scoreCards.map((item) => {
                  const tone = getScoreTone(item.value || 0)
                  const animatedCircleValue = (item.value || 0) * statsAnimProgress
                  return (
                    <StatCard key={item.label} $toneStart={tone.start} $toneEnd={tone.end} $toneBorder={tone.border}>
                      <StatLabel $toneLabel={tone.label}>{item.label}</StatLabel>
                      <CircleWrap $toneHalo={tone.halo}>
                        <Circle size={circleSize} ratio={(item.ratio || 0) * statsAnimProgress} />
                        <Percent $toneBadge={tone.badge}>{formatScoreValue(animatedCircleValue)}</Percent>
                      </CircleWrap>
                    </StatCard>
                  )
                })}
              </StatCircleGrid>
            </CircleSection>
          </MainContainer>
        </MainLayout>
      </Bg>
    )
  } else {
    return (
      <Bg>
        <SideBar />
        <MainLayout>
          <PageHeader icon={statsLogo} title='Statistiques' subtitle='Suivi de progression' />
          Loading ...
        </MainLayout>
      </Bg>
    )
  }
}

const withSaga = injectSaga({
  key: 'refreshSimuPlayers',
  saga: refreshSimuPlayersSaga,
})

const withConnect = connect(null, null)
const arg = compose(withSaga, withConnect)(StatsSimu)

// let arg = compose(withConnect)(StatsSimu)

export default withRouter(arg)
